/* global React */
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog } from '@mui/material'
import { useStyles } from 'platform/react/hook'
import { useCallback, useEffect, useState } from 'react'

/**
 * Styles for the dialog
 *
 * @param {Object} theme             the current theme
 * @param {boolean} [elevated=false] whether the dialog should be displayed above the loader
 * @returns {*&{text: {"& ul": {margin: number, lineHeight: number}, whiteSpace: string}}}
 */
export const styles = (theme, { elevated }) => ({
  root: {
    ...elevated && {
      zIndex: theme.zIndex.modal + 2,
    },
  },
  text: {
    whiteSpace: 'pre-wrap',
    '& ul': {
      margin: 0,
      lineHeight: 1,
    },
  },
  actions: {
    padding: theme.spacing(2),
  },
  ...theme.custom.alert,
})

/**
 * Simple Alert Dialog
 *
 * @param {Object} props  props for the alert
 * @param {Object} ref    reference to the parent object
 * @returns {JSX.Element}
 */
const Alert = ({ open, title, text, children, maxWidth, ...props }, ref) => {
  const classes = useStyles(styles, { elevated: props.elevated || false })()
  const [state, setState] = useState({ open: false })
  const [nextState, setNextState] = useState({})

  useEffect(() => {
    const newState = { open, title, text, children, maxWidth }
    setState(open ? newState : { ...state, open })
    setNextState(newState)
  }, [open, title, text, children, maxWidth])

  const handleExit = useCallback(() => {
    setState(nextState)
  }, [nextState])

  return (
    <Dialog
      fullWidth
      ref={ref}
      open={state.open}
      className={classes.root}
      maxWidth={state.maxWidth || 'xs'}
      onClose={props.events && props.events.onClose}
      onTransitionExited={handleExit}
    >
      <DialogTitle>
        {state.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          component={'div'}
          className={classes.text}
        >
          {state.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        className={classes.actions}
      >
        {state.children}
      </DialogActions>
    </Dialog>
  )
}

export default Alert
